import React from 'react'
import { useSelector } from 'react-redux'

import { getPatient } from '~/store/reducers/patients'
import { getClientId, getPatientId } from '~/store/reducers/soap'

import { SoapHeaderMenuButton } from '../../soap-menu/SoapHeaderMenuButton'
import PatientDetailsHeader from '../../summary/patient-details/PatientDetailsHeader'
import { PatientMedicalSummaryRail } from '../../summary/PatientMedicalSummaryRail'

import styles from './SoapPatientMedicalRecordRightRail.module.scss'

export const SoapPatientMedicalRecordRightRail = () => {
  const clientId = useSelector(getClientId) ?? ''
  const patientId = useSelector(getPatientId) ?? ''
  const patient = useSelector(getPatient(patientId))

  return (
    <div className={styles.rightRailContainer}>
      <div className={styles.patientDetailsHeader}>
        <PatientDetailsHeader
          actionsSlot={<SoapHeaderMenuButton />}
          clientId={clientId}
          patient={patient}
        />
      </div>
      <PatientMedicalSummaryRail clientId={clientId} patientId={patientId} />
    </div>
  )
}
